import { MAIN_URL, DEFAULT_IMG_URL } from '@lib/constants';
import { SchemaArticleProps, extractAuthorData } from './SchemaArticle.types';

export const buildArticleSchema = ({
  title = 'NAF - Norges Automobil-Forbund | NAF',
  description,
  datePublished,
  dateModified,
  author = 'NAF',
  logo = DEFAULT_IMG_URL,
  url = '',
  imgUrl,
  isAccessibleForFree = true,
  articleSection,
  type = 'Article',
}: SchemaArticleProps) => {
  const isAbsoluteUrl = url?.startsWith('http://') || url?.startsWith('https://');
  const articleUrl = isAbsoluteUrl ? url : `${MAIN_URL}${url}`;
  const imageUrl = imgUrl || DEFAULT_IMG_URL;
  const authorData = extractAuthorData(author);

  const authorSchema: Record<string, any> = authorData.isOrganization
    ? {
        '@type': 'Organization',
        name: authorData.name,
        url: MAIN_URL,
      }
    : {
        '@type': 'Person',
        name: authorData.name,
      };

  if (!authorData.isOrganization && authorData.bio) {
    authorSchema.description = authorData.bio;
  }

  if (!authorData.isOrganization && authorData.imageUrl) {
    authorSchema.image = {
      '@type': 'ImageObject',
      url: authorData.imageUrl,
    };
  }

  if (!authorData.isOrganization && authorData.slug) {
    authorSchema.url = `${MAIN_URL}/artikler?forfatter=${authorData.slug}`;
  }

  return {
    '@context': 'https://schema.org',
    '@type': type,
    '@id': `${articleUrl}#article`,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': articleUrl,
    },
    headline: title,
    ...(description && { description }),
    ...(imageUrl && {
      image: {
        '@type': 'ImageObject',
        url: imageUrl,
      },
    }),
    ...(datePublished && { datePublished }),
    ...(dateModified && { dateModified }),
    inLanguage: 'no-NO',
    author: authorSchema,
    publisher: {
      '@type': 'Organization',
      '@id': 'https://naf.no/#organization',
      name: 'NAF',
      ...(logo && {
        logo: {
          '@type': 'ImageObject',
          url: logo,
        },
      }),
    },
    ...(articleSection && { articleSection }),
    ...(isAccessibleForFree === false && {
      isAccessibleForFree: false,
      hasPart: {
        '@type': 'WebPageElement',
        isAccessibleForFree: false,
        cssSelector: '.paywall',
      },
    }),
    url: articleUrl,
  };
};
